export default function install(Vue, options) {
  var vm = new Vue({
    data: {
      domainPath: "",
      sitename: ""
    }
  });

  Object.defineProperties(Vue.prototype, {
    $domainPath: {
      get: function() {
        if (process.env.NODE_ENV == "development") {
          return "http://" + process.env.DOM_NAME + "/";
        } else {
          return "/";
        }
      }
    },
    $sitename: {
      get: function() {
        return process.env.SITE;
      }
    }
  });
}



//////////////////
// WEBPACK FOOTER
// ./Helpers/Plugins/config.js
// module id = null
// module chunks = 